module.exports = __webpack_public_path__ + "media/images/soar/advantages_clock-2327d38a11e50fad32a0013ad2f4fb3a.png";